import { HeaderButton } from '@/components/HeaderButton';
import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import QuestionCircle from '@/images/QuestionCircle.svg';
import { useAuth } from '@/services/auth';
import { useTheme } from '@mui/material';

interface Props {
    className?: string;
}

export const TipsButton = ({ className }: Props) => {
    const theme = useTheme();
    const { isAnonymous } = useAuth();

    if (isAnonymous) {
        return null;
    }
    return (
        <HeaderButton color="secondary" variant="outlined" id="translate-tips-btn" className={className}>
            <MaskedIcon color={theme.colors.black.main} src={QuestionCircle} size="24px" />
            Tips
        </HeaderButton>
    );
};
